import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useRoleSetupStyles = makeStyles(
  (theme: Theme) => {
    const isDark = theme.palette.mode === 'dark';

    const labelText = {
      fontSize: '0.875rem',
      fontStyle: 'normal',
      lineHeight: 'normal',
      fontWeight: 400,
      color: isDark
        ? 'var(--xlrt-color-ui-white)'
        : 'var(--xlrt-color-ui-gray25)',
    };

    const baseButton = {
      borderRadius: '1000px',
      padding: '0.625rem 4rem',
      textTransform: 'none',
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '150%',
      boxShadow: 'none',
      backgroundColor: isDark
        ? 'var(--xlrt-color-future-green500)'
        : 'var(--xlrt-color-future-green800)',
      color: isDark
        ? 'var(--xlrt-color-ui-gray15)'
        : 'var(--xlrt-color-ui-white)',

      '&:hover': {
        backgroundColor: isDark
          ? 'var(--xlrt-color-future-green500)'
          : 'var(--xlrt-color-future-green800)',
      },
      '&:active': {
        backgroundColor: isDark
          ? 'var(--xlrt-color-future-green500)'
          : 'var(--xlrt-color-future-green800)',
      },
    };

    const cardWrapper = {
      display: 'flex',
      width: '15.688rem', // 251px;
      padding: '1rem',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1rem',
      borderRadius: '1rem',
      border: isDark
        ? '1px solid var(--xlrt-color-ui-gray40)'
        : '1px solid var(--xlrt-color-ui-gray75)',
      background: isDark
        ? 'var(--xlrt-color-ui-gray15)'
        : 'var(--xlrt-color-ui-gray90)',
      cursor: 'pointer',

      '&.selected': {
        border: isDark
          ? '1px solid var(--xlrt-color-future-green500)'
          : '1px solid var(--xlrt-color-future-green900)',
        background: isDark
          ? 'rgba(46, 255, 175, 0.02)'
          : 'rgba(0, 168, 104, 0.10)',
      },

      '& .icon': {
        fontSize: '1.75rem',
        color: isDark ? '#E8EAED' : 'var(--xlrt-color-ui-gray25)',
      },

      '& .label': {
        ...labelText,
        textAlign: 'center',
        lineHeight: '150%',
      },
    };

    return {
      container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1 0 0',
        gap: '3rem',
        background: isDark
          ? 'var(--xlrt-color-ui-gray15)'
          : 'var(--xlrt-color-ui-gray90)',

        '& .headerWrapper': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem',

          '& .headerTitle': {
            color: isDark
              ? 'var(--xlrt-color-ui-white)'
              : 'var(--xlrt-color-ui-gray25)',
            textAlign: 'justify',
            fontSize: '2rem',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '2.5rem',
            letterSpacing: '0.32px',
          },

          '& .headerDesc': {
            ...labelText,
            textAlign: 'center',
            fontSize: '1rem',
            lineHeight: '150%',
          },
        },

        '& .roleWrapper': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '1rem',

          '& .roleRowWrapper': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '1rem',

            '& .roleItemWrapper': {
              ...cardWrapper,
            },
          },
        },

        '& .researchPanelInterestOptionWrapper': {
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',

          '& .researchPanelInterestOptionItemWrapper': {
            ...cardWrapper,
          },
        },

        '& .roleButtonWrapper': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1.5rem',
        },

        '& .researchPanelInterestButtonWrapper': {
          display: 'flex',
          alignItems: 'flex-start',
          gap: '.5rem',
        },

        '& .buttonFilled': {
          ...baseButton,

          '&.Mui-disabled': {
            backgroundColor: isDark
              ? 'var(--xlrt-color-ui-gray40)'
              : 'var(--xlrt-color-ui-gray85)',
            color: isDark
              ? 'var(--xlrt-color-ui-gray75)'
              : 'var(--xlrt-color-ui-gray60)',
          },
        },

        '& .backButton': {
          ...baseButton,

          backgroundColor: isDark
            ? 'var(--xlrt-color-ui-gray15)'
            : 'var(--xlrt-color-ui-gray90)',
          color: isDark
            ? 'var(--xlrt-color-ui-white)'
            : 'var(--xlrt-color-ui-gray25)',

          '&:hover': {
            backgroundColor: isDark
              ? 'var(--xlrt-color-ui-gray15)'
              : 'var(--xlrt-color-ui-gray90)',
          },
          '&:active': {
            backgroundColor: isDark
              ? 'var(--xlrt-color-ui-gray15)'
              : 'var(--xlrt-color-ui-gray90)',
          },
        },
      },
      infoWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',

        '&.fixed': {
          position: 'absolute',
          bottom: '37px',
        },

        '& .icon': {
          fontSize: '1.5rem',
          color: isDark
            ? 'var(--xlrt-color-ui-gray75)'
            : 'var(--xlrt-color-ui-gray40)',
        },

        '& .infoText': {
          ...labelText,
          color: isDark
            ? 'var(--xlrt-color-ui-gray75)'
            : 'var(--xlrt-color-ui-gray40)',
          lineHeight: '150%',
        },
      },
    };
  },
  { name: 'RoleSetup' },
);
